import React from 'react';
import { withTranslation } from 'react-i18next';
import { getUrlDomain } from 'src/helpers';
import { useCookie } from 'src/hooks';
import { Box, Flex, Text, PositionBox, StyledButton } from 'src/kit';

const CookiePolicyBar = ({ t, cookiePolicySSR = false }) => {
  const [isCookiePolicyAccepted, setCookiePolicy] = useCookie('cookiePolicy', cookiePolicySSR);
  if (isCookiePolicyAccepted) return null;

  const handleCookiePolicyAcceptance = () => {
    setCookiePolicy(true, {
      path: '/',
      expires: 99999999,
      domain: `.${getUrlDomain()
        .split('.')
        .slice(-2)
        .join('.')}`
    });
  };

  return (
    <PositionBox
      position="fixed"
      bottom={0}
      zIndex={10001}
      py={{ xs: 10, md: 20 }}
      px={{ xs: 10, sm: 20, md: 40, lg: 60 }}
      width={1}
      bg="cookieBg"
      css={{ pointerEvents: 'none' }}
    >
      <Flex
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems="center"
        height="100%"
      >
        <Text
          flex={6}
          mb={{ xs: 1, sm: 0 }}
          mr={{ xs: 0, sm: 10 }}
          color="white"
          fontSize={{ xs: '12px', sm: '12px', md: '14px' }}
          lineHeight={1.43}
          textAlign={{ xs: 'center', sm: 'left' }}
        >
          {t('cookiePolicy')}
        </Text>
        <Box flex={1}>
          <StyledButton ml="auto" width={96} height={34} bg="white" fontSize={0} onClick={handleCookiePolicyAcceptance}>
            {t('Accept')}
          </StyledButton>
        </Box>
      </Flex>
    </PositionBox>
  );
};

export default withTranslation('translations')(CookiePolicyBar);
